import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import categoriesList from "../../constants/advertising_iab_categories.json";
import {
  designTypes,
  qrFramesInitialState,
  qrOptionsInitialState,
  qrTextInitialState,
} from "../../constants/common";
let token = window.token;

export const getPropertiesEntry = createAsyncThunk(
  "getPropertiesEntry",
  async ({ id, frameConfigs }) => {
    try {
      const { data } = await axios.get(`/entry/get-properties/${id}`);
      const properties = JSON.parse(data.data);
      const frame = frameConfigs.find(
        (item) => item.name === properties?.qrFrames?.frame
      );
      const transformParams = {};
      if (frame) {
        transformParams.frameTransform = frame.transformQr;
        transformParams.transformFrameText = frame.transformFrameText;
      }
      return {
        data: { id: Number(id), ...properties },
        qrTitle: data.qrTitle,
        ...transformParams,
      };
    } catch (error) {}
  }
);

export const getAllCategories = createAsyncThunk("getAllCategories", () => {
  return categoriesList;
});

export const getLogout = createAsyncThunk("logout", async () => {
  const response = await axios.get("/logout");
  return response.data;
});

export const saveVisualizationPost = createAsyncThunk(
  "saveVisualization",
  async (data) => {
    const response = await axios.post("/qrvisualization/save", {
      id: JSON.stringify(data[0]),
      image: JSON.stringify(data[1]),
      description: JSON.stringify(data[2]),
      token: JSON.stringify(token),
    });
    return response.data;
  }
);

export const getAllTemplates = createAsyncThunk(
  "getAllTemplates",
  async ({ frameConfigs, savedTemplatesGetUrl }) => {
    const { data } = await axios.get(
      savedTemplatesGetUrl || "/qr-code-generator-template/get-qr-templates"
    );
    return data.map((item) => {
      if (item.template.designType === designTypes.art) {
        return {
          ...item,
          template: {
            ...item.template,
            qrFrames: qrFramesInitialState,
            qrOptions: qrOptionsInitialState,
            qrText: qrTextInitialState,
          },
        };
      }
      const { transformQr, transformFrameText, transformQrWithText } =
        frameConfigs.find(
          (frame) => frame.name === item.template.qrFrames.frame
        );
      return {
        ...item,
        template: {
          ...item.template,
          designType: designTypes.base,
          qrFrames: {
            ...item.template.qrFrames,
            frameTransform:
              item.template.qrFrames.frame === "noFrame" &&
              item.template.qrFrames.frameTextToggle
                ? transformQrWithText
                : transformQr,
            transformFrameText: transformFrameText,
          },
        },
      };
    });
  }
);

export const getPreMadeTemplates = createAsyncThunk(
  "getPreMadeTemplates",
  async (frameConfigs) => {
    const { data } = await axios(
      "https://me-qr.com/qr-code-generator-template/get-pre-made-design-qr"
    );
    return data.map((item, index) => {
      const { transformQr, transformFrameText } = frameConfigs.find(
        (frame) => frame.name === item.qrFrames.frame
      );
      return {
        id: index,
        ...item,
        qrFrames: {
          ...item.qrFrames,
          frameTransform: transformQr,
          transformFrameText: transformFrameText,
        },
      };
    });
  }
);

export const saveQrTemplate = createAsyncThunk(
  "saveQrTemplate",
  async ({ data, savedTemplatesSaveUrl }) => {
    let response = null;
    try {
      response = await axios.post(
        savedTemplatesSaveUrl || "/qr-code-generator-template/save-qr-template",
        {
          ...data,
          qrText: {
            frameText: data.qrText.frameText,
            ...(data.qrText.textSize !== -1 && {
              textSize: data.qrText.textSize,
            }),
          },
          // qrFrames: undefined,
          // qrOptions: undefined,
          // qrText: undefined,
          qrFrames: {
            frame: data.qrFrames.frame,
            frameColor: data.qrFrames.frameColor,
            frameTextColor: data.qrFrames.frameTextColor,
            frameTextToggle: data.qrFrames.frameTextToggle,
            frameTextFont: data.qrFrames.frameTextFont,
          },
        }
      );
    } catch (error) {
      response = error.response;
    } finally {
      return { ...response.data, ...data };
    }
  }
);

export const deleteQrTemplate = createAsyncThunk(
  "deleteQrTemplate",
  async ({ id, savedTemplatesDeleteUrl }) => {
    let response = null;
    try {
      response = await axios.post(
        savedTemplatesDeleteUrl
          ? `${savedTemplatesDeleteUrl}/${id}`
          : `/qr-code-generator-template/delete-qr-template/${id}`
      );
      return id;
    } catch (error) {
      response = error.response;
    }
  }
);

export const getPropertiesTemplateService = createAsyncThunk(
  "getPropertiesTemplateService",
  async ({ frameConfigs, initTemplate }) => {
    try {
      const { data } = await axios.get(initTemplate);
      const properties = data.template;
      const frame = frameConfigs.find(
        (item) => item.name === properties?.qrFrames?.frame
      );
      const transformParams = {};
      if (frame) {
        transformParams.frameTransform = frame.transformQr;
        transformParams.transformFrameText = frame.transformFrameText;
      }
      return {
        data: properties,
        id: data.id,
        ...transformParams,
      };
    } catch (error) {}
  }
);